// extracted by mini-css-extract-plugin
export default {"root":"styles_root__d9L+-","modal-text":"styles_modal-text__Mp+4e"};